import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import Breadcrumb from "../../Components/Common/Modules/Breadcrumb";
import ErrorGenerico from "../../Components/Features/ErrorGenerico";
import ErrorNoCoincide from "../../Components/Features/MiClub/ErrorNoCoincide";
import ErrorVincular from "../../Components/Features/MiClub/ErrorVincular";
import ErrorYaExisteRelacion from "../../Components/Features/MiClub/ErrorYaExisteRelacion";
import ErrorBoundary from "../../Components/Common/Organism/ErrorBoundary";

import FormularioCorto from "../../Components/Features/MiClub/FormularioCorto";
import FormularioLargo from "../../Components/Features/MiClub/FormularioLargo";

import useObtenerDatosClub from "../../Hooks/useObtenerDatosClub";
import ApiService from "../../Services/ApiService";
import SessionHandler from "../../Handlers/Session";
import ProteccionDatosPersonales from "../../Components/Features/MiClub/ProteccionDatosPersonales";
import NoRecordasTarjeta from "../../Components/Features/MiClub/NoRecordasTarjeta";
import Metering from "../../Handlers/Metering";
import LoadingSpinner from "../../Helpers/LoadingSpinner";
import Hotjar from "../../Handlers/Hotjar";
import TitleWeb from "../../Components/Common/Web/Title";
import Datadog from "../../Helpers/Datadog";
import { CustomEventsDatadog, CustomEventsErrorDatadog } from "../../Config/Datadog";
import PathsConfig from "../../Config/RoutePaths";

const Vincular = () => {
  const [error, setError] = useState();
  const [intentos, setIntentos] = useState(3);
  const history = useHistory();
  const [dataClub, errorClub, isLoading] = useObtenerDatosClub();
  const [isLoadingCredencial, setIsLoadingCredencial] = useState(false);

  const esCorto = (dataClub, intentos) => {
    return (
      dataClub &&
      intentos > 0 &&
      dataClub.code === "1" &&
      dataClub.response &&
      dataClub.response.length === 1
    );
  };

  const esMedio = (dataClub, intentos) => {
    return (
      dataClub &&
      intentos > 0 &&
      dataClub.code === "1" &&
      dataClub.response &&
      dataClub.response.length > 1
    );
  };

  const esLargo = (dataClub, intentos) => {
    return dataClub && (dataClub.code === "2" || intentos <= 0);
  };

  const onIntentoError = () => {
    setError(<ErrorNoCoincide></ErrorNoCoincide>);
    setIntentos(intentos - 1);
  };

  const vincular = (params) => {
    setIsLoadingCredencial(true);
    return ApiService.post(
      `${process.env.REACT_APP_APILOGIN}Usuario/AsociarCredencial`,
      params
    )
      .then((data) => {
        if (data && data.code === "1") {
          Datadog.trackCustomEvent(CustomEventsDatadog.vincularCredencial, { sitioOrigen: "Myaccount" });
          const redirect = () => {
            history.push({
              pathname: PathsConfig.MiClub,
              state: {
                succes: true,
              },
            });
          };
          SessionHandler.Reload()
            .then(() => Metering.obtenerCookieSuscriptor()) //No debería ser necesario, porque no hay cambio de estado al vincular
            .then(() => {
              setIsLoadingCredencial(false);
              redirect();
            })
            .catch(() => redirect());

          return Promise.resolve(data.response);
        } else {
          if (data.code !== '1') {
            Datadog.trackCustomEventWarning(CustomEventsErrorDatadog.errorVincularCredencial, { sitioOrigen: "Myaccount" });
          }
          setIsLoadingCredencial(false);
          if (!data || !data.code) {
            setError(<ErrorGenerico></ErrorGenerico>);
            return Promise.reject(data);
          }
          switch (data.code) {
            case "-1":
              // Chequeo si el response del -1 error corresponde a credencial ya asociada a otro usuario .
              if (data.message == "Ya existe la relacion") {
                setError(
                  <ErrorYaExisteRelacion
                    email={data.response}
                  ></ErrorYaExisteRelacion>
                );
              } else {
                //sino es un error generico
                setError(<ErrorVincular></ErrorVincular>);
              }
              break;
            case "-2":
              setError(<ErrorNoCoincide></ErrorNoCoincide>);
              break;
            case "-3":
              setError(
                <ErrorYaExisteRelacion
                  email={data.response}
                ></ErrorYaExisteRelacion>
              );
              Hotjar.HotjarTrigger("LN.MiCuenta.Vinculacion.ErrorEmail");
              break;
            default:
              setError(<ErrorGenerico></ErrorGenerico>);
              return Promise.reject(data);
          }
        }
      })
      .catch((error) => {
        setError(<ErrorGenerico></ErrorGenerico>);
        return Promise.reject(error);
      });
  };
  const corto = esCorto(dataClub, intentos);
  const medio = esMedio(dataClub, intentos);

  return (
    <>
      <Breadcrumb
        firstItem="Club LA NACION"
        href="#"
        text="Vincular credencial"
      />

      <TitleWeb text="Vincular credencial" />
      <div className="container-streched">
        {/*Pantalla de carga*/}
        <LoadingSpinner isLoading={isLoading || isLoadingCredencial}>
          {/*Pantalla de error*/}
          <ErrorBoundary error={errorClub}>
            {error}
            {esLargo(dataClub, intentos) && (
              <FormularioLargo OnVincular={vincular} />
            )}

            {(corto || medio) && (
              <FormularioCorto
                Data={dataClub}
                EsIntermedio={medio}
                OnVincular={vincular}
                OnError={onIntentoError}
              ></FormularioCorto>
            )}
            <NoRecordasTarjeta />
            <ProteccionDatosPersonales />
          </ErrorBoundary>
        </LoadingSpinner>
      </div>
    </>
  );
};

export default Vincular;
